import * as React from 'react';
import { connect } from 'react-redux';

interface IMtaHeaderProps {
  title: string;
}

class MtaHeader extends React.Component<IMtaHeaderProps, any> {

  public render() {
    const { title } = this.props;
    return (
      <>
        <h2><strong>{title}</strong></h2>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    title: props.title,
  };
};

export default connect(mapStateToProps, null)(MtaHeader);
